import Image from 'next/image';
import React, { FC } from 'react';

import { IReview } from '@/contentful/utils/reviews';

import IconQuote from './assets/icon-quote.svg';
import IconReviews from './assets/icon-review.svg';

import styles from './part-review-card.module.scss';

interface ParReviewCardProps {
  review: IReview;
}

const PartReviewCard: FC<ParReviewCardProps> = ({
  review: {
    title, description, position, image,
  },
}) => (
  <div className={styles.container}>
    <div className={styles.reviewIconWrap}>
      <IconReviews className={styles.reviewIcon} />
    </div>
    <div className={styles.reviewContentWrap}>
      <div className={styles.quoteIconWrap}>
        <IconQuote />
        <IconQuote />
      </div>
      <figure className={styles.quoteWrap}>
        <blockquote className={styles.quoteContent}>
          {description}
        </blockquote>
        <div className={styles.quoteCredentialWrap}>
          <div className={styles.imageWrap}>
            <Image
              src={image?.src ?? ''}
              alt={image?.alt ?? ''}
              width={image?.width ?? 0}
              height={image?.height ?? 0}
              className={styles.image}
            />
          </div>
          <figcaption className={styles.quoteCredential}>
            <h3 className={styles.reviewTitle}>{title}</h3>
            {position && (
              <p className={styles.reviewRole}>{position}</p>
            )}
          </figcaption>
        </div>
      </figure>
    </div>
  </div>
);

export default PartReviewCard;
